import { InputComponentProps } from './types';
import PositionListTemplateField from './PositionListTamplateFiled';
import CompetencyTemplateField from './CompetencyTemplateFiled';
import { SKILL_FIELD_TYPE_ALIAS } from '../../../constants';
import OfficeTemplateField from './OfficeTemplateField';
import TechnologyTemplateField from './TechnologyTemplateField';

const FIELD_TYPE_TO_COMPONENT: Record<string, { Component: React.FC<InputComponentProps>; isInit: boolean }> = {
  [SKILL_FIELD_TYPE_ALIAS.AVAILABLE_POSITIONS]: {
    Component: PositionListTemplateField,
    isInit: true,
  },
  [SKILL_FIELD_TYPE_ALIAS.AVAILABLE_COMPETENCY_LEVELS]: {
    Component: CompetencyTemplateField,
    isInit: true,
  },
  [SKILL_FIELD_TYPE_ALIAS.AVAILABLE_OFFICES]: {
    Component: OfficeTemplateField,
    isInit: true,
  },
  [SKILL_FIELD_TYPE_ALIAS.AVAILABLE_TECHNOLOGIES]: {
    Component: TechnologyTemplateField,
    isInit: false,
  },
};

export default FIELD_TYPE_TO_COMPONENT;
